export const evaluate_exam_api = {
  evaluate: "host/content/attempt/evaluate",
  evaluateRank: "host/rank/check",
};
